// extracted by mini-css-extract-plugin
export default {"label":"addProcessesModal-label__n6VA4"};